import React, { useEffect, useState } from "react";
import { Styles } from "./styles";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { Navbar, Nav, NavDropdown } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import { NavHashLink } from "react-router-hash-link";
import Logo from "../../assets/images/logos/09.png";
// import Logo from "../../assets/images/logos/logo.png";
import PathConstants from "../../routes/pathConstants";
import LanguageSwitcher from "../language-switcher";
import NavSearchInput from "./navbar-search-input";
import breakpoints from "../../constants/breakpoints";
import { GoHome } from "react-icons/go";

const NavBar = () => {
  //Hocks
  const { t, i18n } = useTranslation();
  const isXl = useMediaQuery({ query: `(max-width: ${breakpoints.xl})` });
  const isLargerThanXl = useMediaQuery({
    query: `(min-width: ${breakpoints.xl})`,
  });

  const isAr = i18n.language === "ar";
  const location = useLocation();
  const isHomePage = location.pathname === PathConstants.HOME;

  // States
  const [data, setData] = useState([
    {
      Name: "الرؤية",
      PageLink: "#vision",

      Id: 8,
    },
    {
      Name: "الأهداف",
      PageLink: "#goals",

      Id: 9,
    },
    {
      Name: "دور المجلس في سويا الجديدة",
      PageLink: "#role-in-new-syria",

      Id: 1,
    },
  ]);
  const [loading, setLoading] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);

  // Auto-close navbar when screen is larger than xl
  useEffect(() => {
    if (isLargerThanXl) {
      setIsCollapsed(false);
    }
  }, [isLargerThanXl]);

  const renderMenuItems = (menuItems) =>
    menuItems?.map((item, i) => {
      const hasChildren = item.SubMenus && item.SubMenus.length > 0;
      return hasChildren ? (
        <NavDropdown
          title={t(item.Name)}
          id={`nav-dropdown-${i}`}
          key={i}
          className={`nav-item nav-ddl font-bold`}
        >
          {item?.SubMenus?.map((child, index) => (
            <NavDropdown.Item
              key={index}
              as={Link}
              to={child.PageLink}
              className={`nav-link  `}
            >
              {t(child.Name)}
            </NavDropdown.Item>
          ))}
        </NavDropdown>
      ) : (
        <Nav.Item className={`nav-item`} key={i}>
          {item?.PageLink.startsWith("#") ? (
            <NavHashLink
              className={`nav-link underline-item `}
              to={`/${item?.PageLink}`}
              smooth
            >
              {item.Name}
            </NavHashLink>
          ) : (
            <Nav.Link
              as={Link}
              className={`nav-link underline-item`}
              to={item.PageLink}
            >
              {item.Name === "Home" ? <GoHome /> : t(item.Name)}
            </Nav.Link>
          )}
        </Nav.Item>
      );
    });

  return (
    <Styles
      isHomePage={isHomePage}
      isCollapsed={isCollapsed}
      isAr={isAr}
      isOpen={isCollapsed}
    >
      <Navbar expand="xl" expanded={isCollapsed}>
        <div className="container">
          <Link className="logo-container" to={PathConstants.HOME}>
            {Logo && (
              <img
                width={"175px"}
                height={"81px"}
                loading="lazy"
                src={Logo}
                alt="Logo"
                className="logo"
              />
            )}
          </Link>

          <Navbar.Toggle
            aria-controls="navbarScroll"
            onClick={() => setIsCollapsed(!isCollapsed)}
          />

          <Navbar.Collapse id="navbarScroll" className="nav-container">
            {loading ? (
              <Nav>
                {Array.from({ length: 4 }).map((_, index) => (
                  <Nav.Item className="nav-link ">
                    <Skeleton key={index} height={35} width={150} />
                  </Nav.Item>
                ))}
              </Nav>
            ) : (
              <Nav>
                {renderMenuItems(data)}
                {/* {data?.length > 0 && (
                  <NavDropdown
                    title={t("More")}
                    id="more-nav-dropdown"
                    className="nav-dropdown"
                  >
                    {data?.map((item, i) => (
                      <NavDropdown.Item
                        key={i}
                        as={Link}
                        to={item.PageLink}
                        className={`nav-link ${
                          location.pathname === item.PageLink
                            ? "active-link"
                            : ""
                        }`}
                      >
                        {t(item.Name)}
                      </NavDropdown.Item>
                    ))}
                  </NavDropdown>
                )} */}
                {/* {isXl && (
                  <>
                    <NavSearchInput />
                    <div className="controllers">
                      <LanguageSwitcher />
                    </div>
                  </>
                )} */}
              </Nav>
            )}
          </Navbar.Collapse>

          {/* {!isXl && (
            <div className="controllers">
              <NavSearchInput />
              <LanguageSwitcher />
            </div>
          )} */}
        </div>
      </Navbar>
    </Styles>
  );
};

export default NavBar;
